import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "children", "tag"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'button',
  type: 'button'
};
var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
    cssModule = props.cssModule,
    children = props.children,
    Tag = props.tag,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = mapToCssModules(classNames(className, 'navbar-toggler'), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    "aria-label": "Toggle navigation"
  }, attributes, {
    className: classes
  }), children || /*#__PURE__*/React.createElement("span", {
    className: mapToCssModules('navbar-toggler-icon', cssModule)
  }));
};
NavbarToggler.defaultProps = defaultProps;
export default NavbarToggler;